import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function PY_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <PY_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <PY_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function PY_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root}>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What are the career opportunities for Python developers?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <ul>
              Python is widely used in web development, data science, artificial
              intelligence, machine learning, automation, and software testing.
              Job roles include Python Developer, Data Scientist, AI Engineer,
              Software Engineer, and Automation Engineer.
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            Is Python a good language to start a programming career?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Yes, Python is an excellent language for beginners due to its
            readability, simplicity, and large community support. It's often
            recommended for people entering fields like data science, AI, and
            web development.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            How much do Python developers earn?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            The salary of Python developers varies by location, experience, and
            industry. In general, entry-level Python developers can expect to
            earn around $60,000 to $80,000 per year, while senior developers or
            those with specialized skills can earn over $100,000 annually.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            How can I advance my career as a Python developer?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            To advance your career, focus on mastering advanced topics like
            concurrency, distributed systems, and software architecture.
            Contributing to open-source projects, building a portfolio of
            real-world applications, and continuously learning new tools and
            technologies (e.g., machine learning, big data) will help you stand
            out.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What skills should I learn along with Python to boost my career?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Along with Python, learning frameworks like Django or Flask for web
            development, data libraries like Pandas and NumPy for data science,
            and tools like Docker or Kubernetes for deployment can enhance your
            skill set. Understanding databases (SQL), version control (Git), and
            cloud platforms (AWS, Azure) are also valuable.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default PY_FAQ_page
